module.exports = __webpack_public_path__ + "img/convert-bomb-logo-icon.5fb6e929.svg";